import * as React from 'react'

import {useUserTheme} from '../../../../../../hooks/useUserTheme'

import {useShouldShowFeedbackForm} from './Feedback.hooks'
import FeedbackForm from './FeedbackForm/FeedbackForm'

import styles from './Feedback.css'

import ServiceMessage from 'src/components/common/ServiceMessage/ServiceMessage'

function Feedback() {
  const shouldShow = useShouldShowFeedbackForm()
  const theme = useUserTheme()

  return shouldShow.visible ? (
    <ServiceMessage
      closeable={false}
      theme={theme}
      containerClassName={styles.container}
      captionClassName={styles.caption}
    >
      <FeedbackForm />
    </ServiceMessage>
  ) : null
}

export default Feedback
